import { getPropertiesSearchParams } from '../../DashboardPendings/utils';
import { PROPERTY_OPERATIONS } from '../../constants';

export const getHeaderUrl = (statisticsState, statusId, selectedIds) => {
  const { selectedOperation, selectedCurrency } = statisticsState;
  const tokkoBrokerHost = localStorage.getItem('tokkoBrokerHost');
  const sign = '∼';

  const operationId = selectedOperation === PROPERTY_OPERATIONS.SALE ? 1 : 2;
  const minimum = statisticsState[selectedOperation][
    selectedCurrency
  ]?.minimum?.replaceAll(sign, '');
  const maximum = statisticsState[selectedOperation][
    selectedCurrency
  ]?.maximum?.replaceAll(sign, '');

  const searchParams = getPropertiesSearchParams({
    currency: selectedCurrency,
    operation_types: [operationId],
    price_from: minimum,
    price_to: maximum,
    statusId,
    selectedIds,
  });

  return `${tokkoBrokerHost}/properties/?search_options=${searchParams}`;
};

export const formatValue = (value) => {
  const sign = '∼';
  const countryFormat = 'es-AR';

  const hasSign = String(value).startsWith(sign);
  const numericPart = hasSign ? String(value).slice(1) : String(value);
  const formatted = Number(numericPart).toLocaleString(countryFormat);

  return hasSign ? sign + formatted : formatted;
};
